import React, { useState, useEffect, useId } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Button, StaticAlert } from './SkepticParts';




const NewsletterUnsubscribeModal = () => {
    const uniqueId = useId();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [error, setError] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [message, setMessage] = useState('You’re about to leave our newsletter. We’ll miss you!');
    const [buttonState, setButtonState] = useState('loading'); //State can be default, loading, disabled
    const requiredParams = ['uuid', 'newsletter', 'key', 'action'];

    useEffect(() => {

        const get_newsletters = async(uuid, key, newsletter_uuid) => {
            try{
                let url = `${window.location.protocol}//${window.location.hostname}:${window.location.port}/members/api/member/newsletters/?uuid=${uuid}&key=${key}`;
                const response = await fetch(url);
                if (!response.ok) {
                    throw new Error(`Fetch API error status code: ${response.status}`);
                }
                const data = await response.json();
                //console.log('Newsletters:', data.newsletters);
                return data.newsletters
        
            }catch(err){
                console.log(err);
                throw new Error(`Error fetching newsletter ID: ${err.message}.`);
            }
        }

        const update_newsletter_settings = async(uuid, key, newsletter_arr) => {
            try{
                let url = `${window.location.protocol}//${window.location.hostname}:${window.location.port}/members/api/member/newsletters/?uuid=${uuid}&key=${key}`;
                const response = await fetch(url, {
                    method: 'PUT',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({uuid: uuid, newsletters: newsletter_arr})
                });
                if (!response.ok) {
                    throw new Error(`Fetch API error status code: ${response.status}`);
                }
                const data = await response.json();
                //console.log('Newsletter settings updated:', data);
                return data;
        
            }catch(err){
                console.log(err);
                throw new Error(`Error updating newsletter settings: ${err.message}.`);
            }
        }
        

        const urlParams = new URLSearchParams(window.location.search);
    
        // Check if all required parameters are present
        const allParamsExist = requiredParams.every(param => urlParams.has(param));
    
        if (allParamsExist) {
            setIsModalOpen(true);
            (async () => {
                try {
                    const newsletters_array = await get_newsletters(urlParams.get('uuid'), urlParams.get('key'), urlParams.get('newsletter'));
                    if(!Array.isArray(newsletters_array)) throw new Error('Newsletter data could not be fetched.');

                    const updatedNewsletters = newsletters_array.filter(nl => nl.uuid !== urlParams.get('newsletter'));

                    await new Promise(resolve => setTimeout(resolve, 1500));

                    await update_newsletter_settings(urlParams.get('uuid'), urlParams.get('key'), updatedNewsletters);
                    setMessage('You have been successfully unsubscribed from our newsletter.');
                    setButtonState('default');

                    // Remove specific parameters
                    window.history.replaceState({}, document.title, '/');
                } catch (err) {
                    setError(true);
                    setErrorMessage(String(err.message) + ' Please try it again.');
                }
            })();
        } else {
            return;
        }
      }, []);

    const handleModalClose = () => {
        setIsModalOpen(false);
    };

    if (!isModalOpen) return null;

    return(
        <>            
            <div onClick={handleModalClose} className={`${isModalOpen ? 'flex' : 'hidden'} skp_modal_wrapper`} role="dialog" aria-modal="true">
                <div className='skp_modal_window' onClick={(e) => e.stopPropagation()}>
                    
                    <motion.div whileHover={{ scale: 1.05, rotate: 12, backgroundColor: "#ff5f5f" }} onClick={handleModalClose} 
                      role="button" className='size-10 bg-skeptic-primary rounded-full absolute top-2 right-2 sm:-top-5 sm:-right-5'>
                          <svg className='absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2' width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" >
                            <mask id={`mask_${uniqueId}`} style={{ maskType: "alpha" }} maskUnits="userSpaceOnUse" x={0} y={0} width={24} height={24}>
                              <rect width={24} height={24} fill="#D9D9D9" />
                            </mask>
                            <g mask={`url(#mask_${uniqueId})`}><path d="M6.4 19L5 17.6L10.6 12L5 6.4L6.4 5L12 10.6L17.6 5L19 6.4L13.4 12L19 17.6L17.6 19L12 13.4L6.4 19Z" fill="white"/></g>
                          </svg>
                    </motion.div>


                    <div id="success_message" className="px-6 flex flex-col justify-center items-center transition-all">
                        <div className="text-5xl">📭 👋</div>
                       {!error && (
                            <> 
                            <h3 className="mt-8 font-bold text-[1.75rem] text-center text-skeptic-charcoal dark:text-skeptic-foreground-dark">{message}</h3>
                            <p className="text-lg mt-1 text-center text-skeptic-charcoal dark:text-skeptic-foreground-dark">
                            </p>
                            <div className="group mt-8">
                                <Button 
                                text={buttonState === 'loading' ? 'Unsubscribing...' : 'Close'} 
                                state={buttonState} 
                                onClick={handleModalClose} />{/* State can be default, loading, disabled */}
                            </div>
                            </>
                       )} 

                       {error && (
                        <div className='mt-10 w-full'>
                            <StaticAlert type="danger" title="Error" message={errorMessage} />
                        </div>
                       )}
    
                    </div>


 
                </div>            
            </div>
        </>
    )
}

export default NewsletterUnsubscribeModal; // Default export